module.exports = __webpack_public_path__ + "static/media/funan_3.13181345.jpg";